import React, { useState } from "react";
import styled from "styled-components";
import { Row, Popover, Drawer, Col } from "antd";
import { useWindowsSize, CustomButton, CloseIcon } from "@cashrent/commonground-elements";
import AuthDialog from "../auth-dialog/AuthDialog";
import BurgerAvatar from "../burger-avatar/BurgerAvatar";
import UserAvatar from "../user-avatar/UserAvatar";
import { useHistory } from "react-router-dom";
import { redirectToNewApp } from "../../../../utils";

const CustomPopover = styled(Popover)`
  .ant-popover-inner {
    border-radius: 15px !important;
  }
`;

const AuthMenu = ({
  currentUser,
  hasNotifications,
  privateNavItems = [],
  publicNavItems = [],
  userNavItems = [],
  onDrawerClose,
  hasDrawerOpen,
}) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const isMobile = useWindowsSize();
  const history = useHistory();

  const handlePopoverClick = () => {
    if (isMobile) {
      setIsDrawerVisible(!isDrawerVisible);
    } else {
      setIsPopoverVisible(!isPopoverVisible);
    }
  };

  const handleOnClose = () => {
    setIsDrawerVisible(false);
    onDrawerClose();
  };

  const handleOnNavigate = (url) => {
    if (url === "/login" || url === "/register") {
      history.push(url);
    } else if (url.startsWith("http")) {
      window.location.assign(url);
    } else {
     redirectToNewApp(url);
    }
  };

  return (
    <Row justify="end" style={{ cursor: "pointer" }}>
      {currentUser.email && (<CustomPopover
        placement="bottomRight"
        trigger="click"
        open={isPopoverVisible && !isMobile}
        onOpenChange={handlePopoverClick}
        content={(
          <AuthDialog
            isMobile={isMobile}
            currentUser={currentUser}
            onNavigate={handleOnNavigate}
            privateNavItems={privateNavItems}
            publicNavItems={publicNavItems}
            userNavItems={userNavItems}
          />
        )}
                             >
        {isMobile && (
          <BurgerAvatar
            currentUser={currentUser}
            hasNotifications={hasNotifications}
          />
        )}
        {!isMobile && (
          <UserAvatar currentUser={currentUser} size={36}/>
        )}
      </CustomPopover>)}

      <Drawer
        title={(
          <Row align="middle" justify="end">
            <Col>
              <CustomButton
                type="text"
                shape="circle"
                icon={<CloseIcon size={15}/>}
                onClick={handleOnClose}
              />
            </Col>
          </Row>
        )}
        headerStyle={{
          paddingTop: 10,
          paddingRight: 10,
          paddingBottom: 0,
          paddingLeft: 10,
          borderBottom: 0,
        }}
        bodyStyle={{
          paddingTop: 0,
          paddingRight: 10,
          paddingBottom: 0,
          paddingLeft: 10,
        }}
        placement="right"
        width={230}
        closable={false}
        onClose={handleOnClose}
        open={(hasDrawerOpen || isDrawerVisible) && isMobile}
      >
        <AuthDialog
          isMobile={isMobile}
          currentUser={currentUser}
          onNavigate={handleOnNavigate}
          privateNavItems={privateNavItems}
          publicNavItems={publicNavItems}
          userNavItems={userNavItems}
        />
      </Drawer>
    </Row>
  );
};

export default AuthMenu;
